import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
  } from '@angular/core';
import * as d3 from 'd3';

import {Speaker} from '../models/speaker';
import {SpeakerService} from '../speaker.service';


@Component({
  selector: 'line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class LineChartComponent implements OnInit {

    // @ViewChild('chart') private chartContainer: ElementRef;
  @Input() category = 'area';
  @Output() onChartClick = new EventEmitter();
  plotData;
  colors = [ '#4f94cd', '#eeaeee', '#f4a460', '#b3ee3a', '#ee7600', '#2e8b57' ];

  public lineChartData:Array<any> = [];

  public lineChartOptions:any = {
    responsive: true
  };
  public lineChartLegend:boolean = true;
  public lineChartType:string = 'line';

  options = {maintainAspectRatio: false,responsive: true,
    scales: { yAxes: [{ ticks: { beginAtZero: true } }] } };

  oldData = {};
  newData = {};
  data = {};

  constructor(private speakerSrv: SpeakerService) {}

  ngOnInit(): void {
    this.speakerSrv.statsChange.subscribe(stats => { this.update(stats); });
  }

  changeView(mode, event) {
    this.speakerSrv.MODE = mode;
  }

  public randomize():void {
    let _lineChartData:Array<any> = new Array(this.lineChartData.length);
    for (let i = 0; i < this.lineChartData.length; i++) {
      _lineChartData[i] = {data: new Array(this.lineChartData[i].data.length), label: this.lineChartData[i].label};
      for (let j = 0; j < this.lineChartData[i].data.length; j++) {
        _lineChartData[i].data[j] = Math.floor((Math.random() * 100) + 1);
      }
    }
    this.lineChartData = _lineChartData;
  }
 
  // events
  public chartClicked(e:any):void {
    console.log(e);
  }
 
  public chartHovered(e:any):void {
    console.log(e);
  }

  update(stats) {
    const years = ['1994', '2014'];
    let cumulative = {'1994': {}, '2014': {}};
    if (Object.keys(stats).length > 0) {
      for (let i = years.length - 1; i >= 0; i--) {
        let l = years[i];
        const objKeys = Object.keys(stats[l])
        for (let j = objKeys.length - 1; j >= 0; j--) {
          let g = stats[l][objKeys[j]];
          if(g['area'] in cumulative[l]) {
            cumulative[l][g[this.category]] += g['relative'];
          }else{
            cumulative[l][g[this.category]] = g['relative'];
          }
        }
      }
      const keys94 = Object.keys(cumulative['1994']).sort(); 
      const values94 = Object.keys(cumulative['1994']).map(key=>cumulative['1994'][key]).map(x => x);
      const keys14 = Object.keys(cumulative['2014']).sort(); 
      const values14 = Object.keys(cumulative['2014']).map(key=>cumulative['2014'][key]).map(x => x);
      
      // Assigning data to line chart data variable
      this.lineChartData = [ {data: values94, label: '1994'}, {data: values14, label: '2014'} ];
      

      this.oldData = {
          labels: keys94,
          datasets: [
              {
                  label: '1994',
                  data: values94,
                  fill: false,
                  borderColor: '#4bc0c0'
              }
            ]
          };
      this.newData = {
        labels: keys14,
        datasets: [
          {
            label: '2014',
            data: values14,
            fill: false,
            borderColor: '#565656'
          }
        ]
      }
    }
  }

  onDataSelect(event) {
    this.onChartClick.emit({src : 'CHART-' + this.category, event : event});
  }

}



// WEBPACK FOOTER //
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/src/app/line-chart/line-chart.component.ts